import {ClientInformationViewModel} from "@hec/api-dtos";

export interface ClientInformationState {
  clientInformation: ClientInformationViewModel | null;
}

export const clientInformationInitialState: ClientInformationState = {
  clientInformation: null,
}
